import { PageController } from '@client/components/_core/layout/PageController';
import { ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { InsurerLimitDrawer } from './InsurerLimitDrawer';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/claims-authority/insurer-limits/edit/$insurerId/$productTypeId',
)({
    staticData: {
        presentation: 'overlay',
        // CUR-2674: the section that opens it shows only with payment approval; the server answers NOT_FOUND without it.
        featureFlag: ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG,
        metadata: {
            title: 'Edit insurer limit',
        },
    },
    params: {
        parse({ insurerId, productTypeId }) {
            return {
                insurerId: BigInt(insurerId),
                productTypeId: BigInt(productTypeId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { insurerId, productTypeId } = Route.useParams();
    return (
        <PageController route={Route}>
            <InsurerLimitDrawer target={{ insurerId, productTypeId }} />
        </PageController>
    );
}
